import { BlockUIServiceInstance } from '../block-ui.module';
import { BlockUIDecoratorSettings } from '../models/block-ui-decorator-settings.model';

export let blockInstanceGuid = 1;

export function BlockUI(blockName?: string, settings: BlockUIDecoratorSettings = {}) {
  if (!settings.scopeToInstance) {
    return function (target?: any, propertyKey?: string) {
      target[propertyKey] = BlockUIServiceInstance.decorate(blockName);
    };
  }


  return function (target?: any, key?: string) {
    const secret = `_${key}-block-ui`;

    Object.defineProperty(target, key, {
      get: function () {
        if (this[secret]) {
          return this[secret];
        }

        const instanceName = `${blockName}-${blockInstanceGuid++}`;
        this[secret] = BlockUIServiceInstance.decorate(instanceName);

        return this[secret];
      },
      set: function (value: any) {
        this[secret] = value;
      },
    });
  };
}


/**
 * A BlockUI instance
 */
export interface NgBlockUI {
	[key: string]: any;

	/**
	 * BlockUI instance name
	 */
	name: string;

	/**
	 * Is BlockUI instance active
	 */
	isActive: boolean;

	/**
	 * Number of start method calls for instance
	 */
	blockCount: number;

	/**
	 * Starts blocking for BlockUI instance
	 */
	start(message?: any): void;

	/**
	 * Update blocking message for BlockUI instance
	 */
	update(message: any): void;

	/**
	 * Stops blocking for BlockUI instance
	 */
	stop(): void;

	/**
	 * Resets blocking for BlockUI instances regardless of how many times start was called
	 */
	reset(): void;

	/**
	 * Resets blocking for all BlockUI instances
	 */
	resetGlobal(): void;

	/**
	* Unsubscribes BlockUI instance
	*/
	unsubscribe(): void;
}
